export default __webpack_public_path__ + "static/media/MS-experience-right-img.1047567e.png";